import get from 'lodash.get';

const getGlobals = (rootState) => get(rootState, 'ws.template.meta.globals', []);

export default getGlobals;
